import { render, staticRenderFns } from "./SwitchProfile.vue?vue&type=template&id=62d9dcbf&"
import script from "./SwitchProfile.vue?vue&type=script&lang=js&"
export * from "./SwitchProfile.vue?vue&type=script&lang=js&"
import style0 from "./SwitchProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VDivider,VRadio,VRadioGroup})
